import React, { useEffect, useState } from 'react';
import { useFetch } from 'src/hooks/useFetch';
import FormPermisos from 'src/pages/dashboard/modals/FormPermisos';
import { Modal } from '..';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
const PermisosUsuarios = (props) => {
  const { fetch: fetchInitialValues, loading: loadingInitialValues } =
    useFetch();
  const [initialValues, setInitialValues] = useState({});
  useEffect(() => {
    fetchInitialValues(`/usuarios/${props.data.id}/permisos`)
      .then((res) => {
        setInitialValues(res.data);
      })
      .catch((e) => {
        toast.error('Error.Intentelo nuevamente o comuniquese con soporte');
        console.log(e);
      });
  }, [fetchInitialValues, props.data.id]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: Yup.object({
      rep_modulo: Yup.number(),
      rep_calls_v: Yup.number(),
      rep_calls_fail_v: Yup.number(),
      rep_calls_bloq_v: Yup.number(),
      rep_por_fecha_v: Yup.number(),
      rep_prefijos_v: Yup.number(),
      rep_ip_v: Yup.number(),
      rep_rep_bloq_v: Yup.number(),
      adm_modulo: Yup.number(),
      adm_ani_v: Yup.number(),
      adm_ani_e: Yup.number(),
      adm_bloq_v: Yup.number(),
      adm_bloq_e: Yup.number(),
      adm_num_bloq_v: Yup.number(),
      adm_num_bloq_e: Yup.number(),
      adm_hist_bloq_v: Yup.number(),
      gra_modulo: Yup.number(),
      gra_min_util_v: Yup.number(),

      env_sms_simple_v: Yup.number(),
      env_sms_simple_e: Yup.number(),
      env_sms_masivo_v: Yup.number(),
      env_sms_masivo_e: Yup.number(),
      rep_sms_modulo: Yup.number(),
      rep_sms_status_env_v: Yup.number(),
      rep_sms_por_dia_v: Yup.number(),
      rep_sms_por_fecha_v: Yup.number(),
      rep_sms_env_v: Yup.number(),
      rep_sms_rec_v: Yup.number(),
      env_sms_sim_ng_v: Yup.number(),
      env_sms_sim_ng_e: Yup.number(),
      env_sms_mas_ng_v: Yup.number(),
      env_sms_mas_ng_e: Yup.number(),
      api_doc_sms_ng_v: Yup.number(),
      api_doc_sms_ng_e: Yup.number(),
      status_sms_ng_v: Yup.number(),
      status_sms_ng_e: Yup.number(),
      rep_sms_ng_mod: Yup.number(),
      rep_sms_status_ng_v: Yup.number(),
      rep_sms_dia_ng_v: Yup.number(),
      rep_sms_fecha_ent_ng_v: Yup.number(),
      rep_sms_fecha_sal_ng_v: Yup.number(),
      rep_sms_env_ng_v: Yup.number(),
      rep_sms_rec_ng_v: Yup.number(),
      tick_modulo: Yup.number(),
      tick_req_v: Yup.number(),
      tick_req_e: Yup.number(),
      tick_inc_v: Yup.number(),
      tick_inc_e: Yup.number(),
      mv_modulo: Yup.number(),
      mv_list_v: Yup.number(),
      mv_list_e: Yup.number(),
      dash_modulo: Yup.number(),
      dash_tel_v: Yup.number(),
      dash_sms_v: Yup.number(),
      dash_sms_ng_v: Yup.number(),
      cnf_modulo: Yup.number(),
      cnf_usua_v: Yup.number(),
      cnf_usua_e: Yup.number(),
      mod_id: Yup.number(),
      hist_modulo: Yup.number(),
      hist_action_v: Yup.number(),
    }),
    onSubmit: async (values) => {
      try {
        Reflect.deleteProperty(values, 'mod_id');
        Reflect.deleteProperty(values, 'mod_estado');

        await fetch(`/usuarios/${props.data.id}/permisos`, {
          method: 'PATCH',
          data: { ...values },
        });
        toast.success('Permisos modificados con exito');
      } catch (error) {
        toast.error('No se ha podido guardar los cambios');
        console.error(error);
      }
    },
  });
  const { open, close, afterConfirm } = props;
  const { fetch } = useFetch();
  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const confirmHandler = async () => {
    try {
      Reflect.deleteProperty(formik.values, 'mod_id');
      Reflect.deleteProperty(formik.values, 'mod_estado');
      await fetch(`/usuarios/${props.data.id}/permisos`, {
        method: 'PATCH',
        data: { ...formik.values },
      });
      toast.success('Permisos modificados con exito');
    } catch (error) {
      toast.error('No se ha podido guardar los cambios');
      console.error(error);
    }
    afterConfirm();
    close();
  };
  return (
    <Modal
      title={`Permisos Usuarios`}
      content={
        <>
          <FormPermisos
            id={props.data.id}
            formik={formik}
            loading={loadingInitialValues}
          />
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
      maxWidth={props.maxWidth}
    />
  );
};

export default PermisosUsuarios;
